import { Input, Tooltip } from "antd"
import { TooltipPlacement } from "antd/es/tooltip"
import { ReactComponent as QUESTION } from "../../assets/Question.svg"
const { TextArea } = Input

type BaseInputAreaType = {
    classProps?: string
    variant?: "outlined" | "borderless" | "filled" | undefined
    label: string
    value?: string
    placeholder?: string
    onChange: (e: any) => void
    disabled?: boolean
    explainText?: {
        palcement?: string
        text: string
    }
}

export default function BaseInputArea(props: BaseInputAreaType) {
    return (
        <div className={`flex flex-col w-full ${props.classProps}`}>
            <label className="text-sm px-2 pb-1 flex gap-2">
                {props.label}
                {props.explainText && (
                    <Tooltip placement={(props.explainText.palcement as TooltipPlacement) ?? "topRight"} arrow={false} title={props.explainText.text}>
                        <QUESTION className="w-5 h-5" />
                    </Tooltip>
                )}
            </label>
            <TextArea
                value={props.value ?? undefined}
                variant={props.variant}
                disabled={props.disabled}
                onChange={(e) => props.onChange(e.target.value)}
                placeholder={props.placeholder}
                autoSize={{
                    minRows: 6,
                    maxRows: 12,
                }}
                className="rounded-default w-full"
            />
        </div>
    )
}
